export const addFeesAction = (fees) => {
    return (dispatch, getState, { getFirebase }) => {
      const firestore = getFirebase().firestore();
      //console.log(fees);
      firestore
        .collection("students")
        .doc(fees.id)
        .update({
            feesPaid: fees.feesPaid,
            feesBalance: fees.feesBalance,
            feesDate: fees.feesDate,
            feesTerm: fees.feesTerm
        })
        .then(() => {
          dispatch({
            type: "ADD_FEES",
            success: true
          });
        })
        .catch((err) => {
          dispatch({
            type: "ADD_FEES_ERR",
            err
          });
          //console.log(err)
        });
    };
  };
  